import { eventChannel, END } from 'redux-saga';
import { take, put } from 'redux-saga/effects';


const createRequestChannel = progressType => (request, args) => eventChannel(
    emitter => {
        const onProgress = event => {
            const totalLength = event.lengthComputable
                ? event.total
                : event.target.getResponseHeader('content-length');
            emitter({
                indeterminate: !totalLength,
                value: totalLength ? event.loaded / totalLength : 0,
            });
        };
        let cancel = () => {};
        (async () => {
            // break out of event loop
            await Promise.resolve();

            emitter({ indeterminate: true });
            try {
                const result = await request({
                    ...args,
                    [progressType]: onProgress,
                    setCancel: c => {
                        cancel = c;
                    },
                });
                emitter({ done: true, result });
            } catch (error) {
                emitter({ error });
            }
            emitter(END);
        })();
        return () => cancel();
    },
);

export const createDownloadChannel = createRequestChannel('onDownloadProgress');
export const createUploadChannel = createRequestChannel('onUploadProgress');

export function* runChannel(channel, getProgressAction, getFinishAction) {
    try {
        while (true) {
            const { error, done, result, ...progress } = yield take(channel);
            if (error)
                throw error;

            if (done)
                return result;

            yield put(getProgressAction(progress));
        }
    } finally {
        yield put(getFinishAction());
    }
}

export const augmentSaga = (saga, ...wrapperSagas) => wrapperSagas.reduceRight(
    (saga, wrapperSaga) => function* aurmenter(...args) {
        yield wrapperSaga(() => saga(...args))(...args);
    },
    saga,
);
